export const login = {
    login: 'เข้าสู่ระบบ',
    username: {
        name: 'ชื่อเข้าใช้งาน',
        placeholder: 'ชื่อเข้าใช้งาน',
        required: 'กรุณากรอก ชื่อผู้ใช้งาน',
        too_short: '',
        invalid: '',
    },
    password: {
        name: 'รหัสผ่าน',
        placeholder: 'รหัสผ่าน',
        required: 'กรุณากรอก รหัสผ่าน',
        too_short: '',
        invalid: '',
    },
    forget_password: 'ลืมรหัสผ่าน?',
    err_login: {
        title: 'ชื่อเข้าใช้งานหรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง',
    }
}
